module.exports = __webpack_public_path__ + "static/toggl-track-profit-losses-fb5dd923a88c2818e3da721aca15f153.jpg";